<template>
    <div class="CLASS_TITLE">
        <el-divider content-position="left">PAGETITLE</el-divider>
        <el-table max-height="650" :data="tablelData" style="width: 100%; margin-top: 10px" border :size="YSYSIZE"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
            }">
            <el-table-column prop="id" label="序号" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="advice_name" label="精彩榜" align="center">
            </el-table-column>
            <el-table-column prop="total" label="数量" align="center">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
  name: 'VUENAME'
}
</script>

<style scoped>
.CLASS_TITLE {
    /* margin-left: 3.6rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/TycModel.vue